import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const lines = [
    { text: "FREE FOOD", accent: "#0D9488" },
    { text: "FREE DRINK", accent: "#FF5E3A" },
    { text: "FREE ACCOMMODATION", accent: "#FACC15" },
];

export default function ValueSection() {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"],
    });
    const xLeft = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
    const xRight = useTransform(scrollYProgress, [0, 1], ["10%", "-10%"]);

    return (
        <section
            ref={ref}
            id="perks"
            data-testid="value-section"
            className="relative py-24 sm:py-36 overflow-hidden bg-[#FAF9F6]"
        >


            <div className="space-y-2 sm:space-y-4">
                {lines.map((l, idx) => {
                    const x = idx % 2 === 0 ? xLeft : xRight;
                    return (
                        <motion.div
                            key={l.text}
                            style={{ x }}
                            className="flex items-center gap-6 whitespace-nowrap"
                        >
                            <span
                                className="ais-mega text-slate-900"
                                style={{ WebkitTextStroke: "0" }}
                            >
                                {l.text}
                            </span>
                            <span
                                className="ais-mega"
                                style={{
                                    color: "transparent",
                                    WebkitTextStroke: `2px ${l.accent}`,
                                }}
                            >
                                {l.text}
                            </span>
                            <span
                                className="ais-mega"
                                style={{ color: l.accent }}
                            >
                                {l.text}
                            </span>
                        </motion.div>
                    );
                })}
            </div>
        </section>
    );
}
